import { render, staticRenderFns } from "./UpdateSubTagModal.vue?vue&type=template&id=44f5e791"
import script from "./UpdateSubTagModal.vue?vue&type=script&lang=js"
export * from "./UpdateSubTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports